import { combineReducers } from '@reduxjs/toolkit';

import { attributesReducer } from './attributesSlice';

export const commonReducer = combineReducers({
  attributes: attributesReducer,
});
